module.exports = __webpack_public_path__ + "static/IMG-20200726-WA0015-79106f5cd35a07dbc15394f0278767ca.jpg";